<template>
  <div class="my-6 p-2 historico" v-if="historicos">
    <!-- Title -->
    <div class="flex items-center gap-5 historico__title">
      <feather-icon icon="ClockIcon" />
      <h4>Histórico de observações</h4>
    </div>

    <!-- Container -->
    <div class="historico__container">
      <!-- Tabela em Desktop -->
      <div class="showDesktop">
        <table v-if="historicos.length > 0">
          <thead>
            <th style="width: 15%">Usuário</th>
            <th style="width: 50%">Observações</th>
            <th style="width: 10%">Data</th>
            <th style="width: 10%">Hora</th>
            <th style="width: 15%">Situação</th>
          </thead>
          <tbody>
            <tr v-for="item in historicos" :key="item.idHistoricoObservacao">
              <td>{{ item.usuario }}</td>
              <td style="max-width: 50%">
                <div v-html="item.observacao"></div>
              </td>
              <td style="max-width: 10%">{{ item.data }}</td>
              <td style="max-width: 10%">{{ item.hora }}</td>
              <td>
                <vs-chip
                  v-if="item.situacao"
                  class="rounded chip-historico-eventos"
                  :color="item.corSituacao"
                >
                  {{ item.situacao }}
                </vs-chip>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Collapse em mobile -->
      <vs-collapse v-if="historicos.length > 0" class="showMobile">
        <vs-collapse-item
          v-for="item in historicos"
          :key="item.idHistoricoObservacao"
        >
          <div slot="header">
            <p><b>Usuário:</b> {{ item.usuario }}</p>
            <p><b>Data:</b> {{ item.data }}</p>
          </div>
          <div>
            <p><b>Hora:</b> {{ item.hora }}</p>
            <p><b>Situação:</b> {{ item.situacao }}</p>
            <p><b>Observação:</b> <span v-html="item.observacao"></span></p>
          </div>
        </vs-collapse-item>
      </vs-collapse>

      <!-- Mensagem quando não há histórico -->
      <div v-else>
        <p class="p-5">Não há registros anteriores.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['historicos'],
  data() {
    return {
      usuario: null,
      observacao: null,
      data: null,
      hora: null,
      situacao: null,
    };
  },
  methods: {},
};
</script>

<style>
.colorBlue {
  color: #00bfed;
}

.showDesktop {
  display: block;
}

.showMobile {
  display: none;
}

.chip-historico-eventos span {
  font-weight: 700;
}

@media (max-width: 500px) {
  .showDesktop {
    display: none;
  }

  .showMobile {
    display: block;
  }
}
</style>

<style lang="scss" scoped>
.historico {
  font-size: 14px;

  &__title {
    margin-bottom: 24px;

    h4 {
      font-weight: 700;
    }
  }

  &__container {
    border-radius: 16px;
    background: #fff;
    box-shadow: 0px 0px 12px 4px rgba(0, 0, 0, 0.06);

    table {
      border-spacing: 0px;
      border-radius: 16px;
      overflow: hidden;
      width: 100%;

      width: 100%;

      th {
        background: rgba(195, 225, 255, 0.5);
        color: #114880;
        font-size: 14px;
        text-transform: uppercase;
        padding: 16px;
      }

      td {
        padding: 16px;
        vertical-align: top;
      }

      tr:nth-child(even) {
        background: #f5f5f5;
      }
    }
  }
}
</style>
